import Axios from "../config/axios-v1-config";

// Backend del wizard de facturación (microservice-invoicing, vía BFF).
// Ruta: /api/v1/invoicing/fiscal-config/*  (la base del axios ya antepone /api/v1).
const BASE = "/invoicing/fiscal-config";

// Retoma la configuración del operador para (país, ambiente). 404 = aún no existe.
export const getFiscalConfig = (country, environment) =>
  Axios.get(BASE, { params: { country, environment } });

// Paso identidad: crea/actualiza el registro.
export const upsertFiscalConfig = (data) => Axios.post(BASE, data);

// Paso certificado (multipart). El .pfx/PEM y la contraseña se cifran en el backend.
export const uploadCertificate = (id, file, password) => {
  const fd = new FormData();
  fd.append("file", file);
  if (password) fd.append("password", password);
  return Axios.put(`${BASE}/${id}/certificate`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// Paso folios CAF (Chile, multipart: XML + tipo de documento).
export const uploadCaf = (id, file, docTypeCode) => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("docTypeCode", docTypeCode);
  return Axios.put(`${BASE}/${id}/caf`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// Paso punto de venta (Argentina).
export const setPointOfSale = (id, pointOfSale) =>
  Axios.put(`${BASE}/${id}/point-of-sale`, { pointOfSale });

// Paso reglas de emisión.
export const setEmissionRules = (id, data) =>
  Axios.put(`${BASE}/${id}/emission-rules`, data);

// Paso prueba de conexión real contra el ente (no emite comprobante).
export const testFiscalConnection = (id) =>
  Axios.post(`${BASE}/${id}/test-connection`);

// Paso declaración de certificación / homologación (solo producción).
export const declareCertification = (id, data) =>
  Axios.put(`${BASE}/${id}/certification`, data);

// Paso final: activar producción.
export const activateFiscalConfig = (id) =>
  Axios.post(`${BASE}/${id}/activate`, { confirmActivation: true });
